export const debounce = (fn, wait = 100) => {
    // this is double debounce
    // it fires like this
    // calls:          1111111111111111
    // actually fired: 1000000000000001

    // so only first and last call

    let shouldCallMore
    let timer
    let maxWaitTimer
    let isWaiting
    let fnArgs = []

    const stopWaiting = () => {
        if (shouldCallMore) fn(...fnArgs)
        isWaiting = shouldCallMore = false
    }

    const call = () => {
        shouldCallMore = false
        fn(...fnArgs)
    }

    return (...args) => {
        fnArgs = args

        shouldCallMore = true

        clearTimeout(timer)
        timer = setTimeout(stopWaiting, wait)

        if (isWaiting) return
        isWaiting = true

        clearTimeout(maxWaitTimer)
        maxWaitTimer = setTimeout(call, 20)
    }
}

export const revealLinksOnAction = (onLinksReady) => {

	const linksLikeItems = document.querySelectorAll('span[data-secret]')

    const makeALink = (linkLikeItem) => {
        const attrs = linkLikeItem.attributes
        const html = linkLikeItem.innerHTML
        const link = document.createElement('a')
        const linkId = linkLikeItem.id
        const isHidden = linkLikeItem.hasAttribute('data-hidden')

        for (const attr of attrs) {
            if (isHidden) {
                const newLink = attr.value.replace('?', 'https://').replace(/%/g, '.').replace(/\$/g, '/')
                link.setAttribute(attr.name, attr.value = newLink)
            } if (linkId === 'share') {
                const newLink = attr.value
                    .replace('?', 'https://')
                    .replace(/%/g, '.').replace(/\$/g, '/')
                    .replace('*', window.configAppUrl)
                link.setAttribute(attr.name, attr.value = newLink)
            }
            else {
                link.setAttribute(attr.name, attr.value)
            }
        }
        link.setAttribute('href', link.dataset.secret)

        link.innerHTML = html
        linkLikeItem.replaceWith(link)
    }

    onUserAction(function () {
        linksLikeItems.forEach(makeALink)
        setTimeout(() => {
            onLinksReady?.()
        }, 1)
    })
}

export const preventScroll = () => {
    const initialPosition = document.documentElement.style.position
    const initialTop = document.documentElement.style.top
    const initialScrollY = window.scrollY
    document.documentElement.style.top = `-${initialScrollY}px`;
    document.documentElement.style.position = 'fixed';

    return () => {
        document.documentElement.style.position = initialPosition;
        document.documentElement.style.top = initialTop;
        window.scrollTo(0, initialScrollY)
    }
}

export const viewportSmall = `(max-width: 50rem)`
export const viewportMedium = `(max-width: 80rem) and (min-width: ${50 * parseFloat(getComputedStyle(document.documentElement).fontSize) + 1}px)`
export const viewportLarge = `(min-width: ${80 * parseFloat(getComputedStyle(document.documentElement).fontSize) + 1}px)`
export const SEO_BR_INFO_PAGE = 'e9d7b173a8230027'

export const watchMedia = (mqs, cb) => {
    const mq = window.matchMedia(mqs)
    const wrapperCb = e => {
        if (!e.matches) return
        cb()
    }

    if (mq.addEventListener) mq.addEventListener('change', wrapperCb)
    else if (mq.addListener) mq.addListener(wrapperCb)

    if (mq.matches) cb()
    return () => {
        if (mq.removeEventListener) mq.removeEventListener('change', wrapperCb)
        else if (mq.removeListener) mq.removeListener(wrapperCb)
    }
}

// is click outside the element
export const isClickOutside = (windowClickEvent, element) => {
    if (!windowClickEvent || !element) return

    const cursorX = windowClickEvent.clientX
    const cursorY = windowClickEvent.clientY

    // this probably happened because clicked with spacebar
    if (cursorX === 0 && cursorY === 0) return false

    const rect = element.getBoundingClientRect()
    const clickedOutsideX = cursorX < rect.left || cursorX > rect.right
    const clickedOutsideY = cursorY < rect.top || cursorY > rect.bottom

    return clickedOutsideX || clickedOutsideY
}

export const getRef = () => {
    const url = window.location.href
    const urlObj = new URL(url)

    let ref = urlObj.searchParams.get('ref')

    if (ref) document.cookie = `ref=${ref}; path=/`
    else if (
        document.referrer
        && document.referrer.length > 0
        && document.referrer.match(/^https?:\/\/([^\/]+\.)?(google|duckduckgo|bing)\.com(\/|$)/i)
    ) ref = '1d1999c8d5115a7b'

    return ref
}

export const saveRefToCookie = ref => {
    if (!ref) return
    document.cookie = `ref=${ref}; path=/`
}

export const attachRefsToStudybayLinks = (ref) => {
    const url = new URL(window.location.href)
    const shouldSetRef = (
        ref &&
        !(url.searchParams.has('ref') || url.searchParams.has('refid'))
    )
    if (shouldSetRef) url.searchParams.append('ref', ref)

    const urlSearch = url.search
    const links = document.querySelectorAll('a')

    links.forEach(link => {
        const href = link.href
        if (!href) return
        const url = new URL(href)
        const hostname = url.hostname
        const pathname = url.pathname
        const hash = url.hash

        const shouldNotUpdateHref = (
            !/(studybay\.|author24\.local)/.test(hostname) ||
            pathname === window.location.pathname ||
            hash
        )

        if (shouldNotUpdateHref) return

        link.setAttribute('href', `${link.href}${urlSearch}`)
    })
}

export const attachRefToRegForms = ref => {
    if (!ref) return

    const fastregForms = document.querySelectorAll('[action*="order/unregordershortform"], [action*="user/fastunregorder"]')
    fastregForms.forEach((form) => {
        let action = form.action

        // if ref is already set - return
        if (/(\?|\/|&)ref(id)?=[0-9a-zA-Z]+/.test(action)) return

        if (/\?.+&?/.test(action)) action = `${action}&ref=${ref}`
        else if (action.endsWith('/')) action = `${action}?ref=${ref}`
        else action = `${action}/?ref=${ref}`

        form.setAttribute('action', action)
    })
}

export const handleRef = () => {
    attachRefsToStudybayLinks()

    const ref = getRef()
    if (!ref) return
    attachRefToRegForms(ref)

    const fastregForms = document.querySelectorAll('[action*="order/unregordershortform"]')
    fastregForms.forEach(form => {
        form.addEventListener('submit', () => saveRefToCookie(ref))
    })
}

export const initSlider = root => {
    const hideElem = elem => elem.setAttribute('hidden', true)
    const showElem = elem => elem.removeAttribute('hidden')

    const start = () => {
        const slider = root.querySelector('.slider')
        const left = root.querySelector('.slider__control--left')
        const right = root.querySelector('.slider__control--right')
        const inner = root.querySelector('.slider__inner')

        let sliderWidth
        let innerWidth
        let scrollingAmount

        const scroll = amount => {
            const before = slider.scrollLeft
            slider.scrollBy(amount, 0)
            setTimeout(() => {
                const after = slider.scrollLeft
                if (before === after) {
                    slider.classList.remove('slider--snap')
                    slider.scrollBy(amount, 0)
                    setTimeout(() => slider.classList.add('slider--snap'), 100)
                }
            }, 30)
        }

        const scrollToLeft = () => scroll(-scrollingAmount)
        const scrollToRight = () => scroll(scrollingAmount)
        const getScrollingAmount = () => Math.ceil((sliderWidth / 3) * 1) // scroll on one element

        const manageControls = debounce(() => {
            const scrollPos = Math.floor(slider.scrollLeft + sliderWidth)
            const isBeginning = Math.abs(scrollPos - sliderWidth) < 20
            const isEnd = Math.abs(scrollPos - innerWidth) < 20

            if (isEnd) hideElem(right)
            else showElem(right)

            if (isBeginning) hideElem(left)
            else showElem(left)
        })

        const fillSliderParams = debounce(() => {
            sliderWidth = Math.ceil(slider.getBoundingClientRect().width)
            innerWidth = Math.ceil(inner.getBoundingClientRect().width)
            scrollingAmount = getScrollingAmount()
            const noNeedToScroll = innerWidth <= sliderWidth

            if (noNeedToScroll) {
                hideElem(left)
                hideElem(right)
                slider.removeEventListener('scroll', manageControls)
                left.removeEventListener('click', scrollToLeft)
                right.removeEventListener('click', scrollToRight)
                return
            }

            manageControls()

            slider.addEventListener('scroll', manageControls)
            left.addEventListener('click', scrollToLeft)
            right.addEventListener('click', scrollToRight)
        })

        window.addEventListener('resize', fillSliderParams)
        fillSliderParams()

        return () => {
            window.removeEventListener('resize', fillSliderParams)
            slider.removeEventListener('scroll', manageControls)
            left.removeEventListener('click', scrollToLeft)
            right.removeEventListener('click', scrollToRight)
        }
    }

    const shouldhaveButtons = CSS.supports('scroll-behavior', 'smooth')// && !isMobile
    if (shouldhaveButtons) return start()
}

export const initAccordion = (accordionRoot) => {

    const accordionBlocks = accordionRoot.querySelectorAll('.accordion');

    accordionBlocks.forEach(accordionBlock => {
        const controller = accordionBlock.querySelector('.accordion__controller');

        controller.addEventListener('click', () => {
            const button = controller.querySelector('.accordion__expander');
            const content = accordionBlock.querySelector('.accordion__content');

            const shouldShowContent= button.getAttribute('aria-expanded') === 'false';

            button.setAttribute('aria-expanded', shouldShowContent);
            if (shouldShowContent) content.removeAttribute('hidden');
            else content.setAttribute('hidden', true);

            button.focus();
        });
    })
}

export const initAutoSlider = ({slider, changeTime=3000}={}) => {
    const items = Array.from(slider.querySelectorAll('.auto-slider__item'))
    const itemsNumber = items.length
    let screenRightBorder = slider.offsetWidth
    let screenMiddle = screenRightBorder / 2
    let centeredIndex = 0

    const firstItem = items[0]
    const lastItem = items[itemsNumber - 1]

    const slide = () => {
        const sliderOffset = slider.getBoundingClientRect().left
        const leftPadding = screenMiddle - firstItem.getBoundingClientRect().width / 2
        const rightPadding = screenMiddle - lastItem.getBoundingClientRect().width / 2

        slider.style.paddingLeft = `${leftPadding}px`
        slider.style.paddingRight = `${rightPadding}px`

        screenRightBorder = slider.offsetWidth
        screenMiddle = screenRightBorder / 2

        const itemsExtendedInfo = items.map((item, index) => {
            const { width } = item.getBoundingClientRect()
            item.outerWidth
            return {
                offsetLeft: item.offsetLeft,
                width,
            }
        })

        if (centeredIndex >= itemsNumber) centeredIndex = 0

        const itemToCenter = itemsExtendedInfo[centeredIndex]
        const halfOfItemToCenter = itemToCenter.width / 2
        const moveTo = itemToCenter.offsetLeft + halfOfItemToCenter - screenMiddle - sliderOffset

        items.forEach((item, index) => {
            if (index === centeredIndex) item.classList.add('auto-slider__item--active')
            else item.classList.remove('auto-slider__item--active')
        })

        slider.scroll({left: moveTo, behavior: 'smooth'})
        centeredIndex++
    }

    slide()
    setInterval(slide, changeTime)
}

export const trapFocus = (root, closeCb = () => {}) => {
    const focusableElementsString = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]'

    const wasInFocus = document.activeElement
    const interactiveElements = Array.from(root.querySelectorAll(focusableElementsString))
    const interactiveElementsCount = interactiveElements.length
    const firstElement = interactiveElements[0]
    const lastElement = interactiveElements[interactiveElementsCount - 1]
    firstElement.focus()

    const keydownHandler = e => {
        const isTab = e.code === 'Tab' && !e.shiftKey
        const isShiftTab = e.code === 'Tab' && e.shiftKey
        const isEsc = e.code === 'Escape'
        const isFirstElementInFocus = document.activeElement === firstElement
        const isLastElementInFocus = document.activeElement === lastElement

        if (isFirstElementInFocus && isShiftTab) {
            e.preventDefault()
            lastElement.focus()
            return
        }

        if (isLastElementInFocus && isTab) {
            e.preventDefault()
            firstElement.focus()
            return
        }

        if (isEsc) {
            e.preventDefault()
            closeCb()
        }
    }

    document.addEventListener('keydown', keydownHandler)

    return () => {
        if (wasInFocus) wasInFocus.focus()
        document.removeEventListener('keydown', keydownHandler)
    }
}

export const addSeoClassNames = () => {
    if (!document.referrer) {
        return;
    }
    document.getElementById('signup-link')?.classList.add('SEO_BR_Info_Registrar');
    document.getElementById('login-link')?.classList.add('SEO_BR_Info_Entrar');
    document.querySelectorAll('.expert__hire')?.forEach(btn => {
        btn.classList.add('SEO_BR_Info_Contratar');
    });
    document.querySelector('#regForm button[type="submit"]')?.classList.add('SEO_BR_Info_Proximo');
    document.querySelector('.experts__become-link')?.classList.add('SEO_BR_Info_Setorne');
}

export const loadingSupportChat = {
    isLoading: false,

    init() {
        this.load = this._load.bind(this)

        window.addEventListener('scroll', this.load)
        document.body.addEventListener('click', this.load)
        document.body.addEventListener('keyup', this.load)
    },

    _load() {
        if (this.isLoading) return
        this.isLoading = true

        window.removeEventListener('scroll', this.load);
        document.body.removeEventListener('click', this.load);
        document.body.removeEventListener('keyup', this.load);

        const script = document.createElement('script');
        script.src = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_160821_27901.js';
        script.async = true;
        document.body.appendChild(script);
    }
}
export const setTimezone = () => {
    const timezoneInputs = document.querySelectorAll('[name="timezone"]')
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    timezoneInputs.forEach(input => input.value = timezone)
}

export function onUserAction(callback) {
	function handler() {
		document.body.removeEventListener('touchmove', handler)
		document.body.removeEventListener('click', handler)
		document.body.removeEventListener('keydown', handler)
		document.body.removeEventListener('mousemove', handler)
  
		callback();
	}
  
	document.body.addEventListener('touchmove', handler)
	document.body.addEventListener('click', handler)
	document.body.addEventListener('keydown', handler)
	document.body.addEventListener('mousemove', handler)
}